import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';
import ImageGallery from './ImageGallery';

const allPhotos = [
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/4v0p12nt_ChatGPT%20Image%204%20mai%202026%2C%2012_01_09.png',
    alt: 'Bureaux - Espace de travail',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/2r27clam_ChatGPT%20Image%204%20mai%202026%2C%2012_01_18.png',
    alt: 'Bureaux - Bureau privé',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/aoweuat2_ChatGPT%20Image%204%20mai%202026%2C%2012_01_23.png',
    alt: 'Bureaux - Détails',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/x8uzm7qm_ChatGPT%20Image%204%20mai%202026%2C%2012_01_37.png',
    alt: 'Bureaux - Espace bureau',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/gvcmpxg5_ChatGPT%20Image%205%20mai%202026%2C%2009_52_33.png',
    alt: 'Salle de Réunion - Espace professionnel',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/btpvsz3w_1.jpg',
    alt: 'Manoir - Extérieur',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/is0t3av2_2.jpeg',
    alt: 'Manoir - Intérieur salon',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/wfo97exu_3.png',
    alt: 'Manoir - Vue extérieure',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/26ltny7t_4.jpeg',
    alt: 'Manoir - Intérieur détails',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/f15e4ggm_5.jpeg',
    alt: 'Manoir - Espace de réception',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/tb4pyzwx_6.jpg',
    alt: 'Manoir - Salle de bain en pierre',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/iqkb3vqn_7.jpeg',
    alt: 'Manoir - Galerie en pierre',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/i3wmpxaz_8.png',
    alt: 'Manoir - Chambre à baldaquin',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/9mm6bqrs_9.png',
    alt: 'Manoir - Chambre avec bibliothèque',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/8awm8ijj_10.jpeg',
    alt: 'Manoir - Salle de bain à l\'ancienne',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/7dlhf6om_11.jpg',
    alt: 'Manoir - Chambre lits jumeaux papier peint',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/o0r1vyll_12.jpeg',
    alt: 'Manoir - Chambre tête de lit rose',
  },
];

const Gallery = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const previewPhotos = allPhotos.slice(0, 5);
  const remainingCount = allPhotos.length - previewPhotos.length;

  const openGallery = (index = 0) => {
    setStartIndex(index);
    setIsGalleryOpen(true);
  };

  return (
    <section className="py-16 md:py-24 premium-blue relative overflow-hidden">
      {/* Decorative orbs */}
      <div className="absolute top-20 -left-32 w-[450px] h-[450px] rounded-full bg-[#FFFFFF]/10 blur-[140px] pointer-events-none"></div>
      <div className="absolute bottom-0 -right-32 w-[500px] h-[500px] rounded-full bg-[#7B9BC0]/15 blur-[140px] pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Découvrez Nos Espaces en Images
          </h2>
          <p className="text-base md:text-xl text-gray-300">
            Des lieux inspirants où il fait bon travailler
          </p>
        </div>

        {/* Image Gallery - Masonry layout with 5 photos */}
        <div
          className="grid grid-cols-2 md:grid-cols-4 grid-rows-2 gap-4 mb-20"
          style={{ height: '620px' }}
          data-testid="gallery-masonry-grid"
        >
          {/* Photo 1 - Large (left, spans 2 cols and 2 rows) */}
          <button
            onClick={() => openGallery(0)}
            className="md:col-span-2 md:row-span-2 rounded-2xl overflow-hidden shadow-lg group relative cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FFFFFF]"
            data-testid="gallery-photo-0"
          >
            <img
              src={previewPhotos[0].src}
              alt={previewPhotos[0].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
          </button>

          {/* Photo 2 */}
          <button
            onClick={() => openGallery(1)}
            className="rounded-2xl overflow-hidden shadow-lg group relative cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FFFFFF]"
            data-testid="gallery-photo-1"
          >
            <img
              src={previewPhotos[1].src}
              alt={previewPhotos[1].alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
          </button>

          {/* Photo 3 */}
          <button
            onClick={() => openGallery(2)}
            className="rounded-2xl overflow-hidden shadow-lg group relative cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FFFFFF]"
            data-testid="gallery-photo-2"
          >
            <img
              src={previewPhotos[2].src}
              alt={previewPhotos[2].alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
          </button>

          {/* Photo 4 */}
          <button
            onClick={() => openGallery(3)}
            className="rounded-2xl overflow-hidden shadow-lg group relative cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FFFFFF]"
            data-testid="gallery-photo-3"
          >
            <img
              src={previewPhotos[3].src}
              alt={previewPhotos[3].alt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-300"></div>
          </button>

          {/* Photo 5 - With blur + counter overlay */}
          <button
            onClick={() => openGallery(4)}
            className="rounded-2xl overflow-hidden shadow-lg group relative cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#FFFFFF]"
            data-testid="gallery-photo-more"
            aria-label={`Voir toutes les photos (${remainingCount} photos supplémentaires)`}
          >
            <img
              src={previewPhotos[4].src}
              alt={previewPhotos[4].alt}
              className="w-full h-full object-cover blur-sm scale-110 group-hover:blur-[2px] transition-all duration-500"
            />
            <div className="absolute inset-0 bg-black/55 group-hover:bg-black/45 transition-colors duration-300 flex flex-col items-center justify-center">
              <span className="text-white text-4xl md:text-5xl font-bold leading-none">
                +{remainingCount}
              </span>
              <span className="text-white font-bold text-sm md:text-base mt-2 tracking-wider uppercase font-medium">
                Voir toutes les photos
              </span>
            </div>
          </button>
        </div>

        {/* Testimonials */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-12 border border-white/10">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Ils Nous Font Confiance
            </h3>
            <p className="text-gray-300">
              Découvrez les témoignages de nos membres
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 hover:border-[#FFFFFF] transition-all duration-300"
              >
                {/* Stars */}
                <div className="flex space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="fill-[#FFFFFF] text-white font-bold" size={18} />
                  ))}
                </div>

                {/* Content */}
                <p className="text-gray-200 mb-6 leading-relaxed italic">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div>
                  <p className="font-bold text-white">{testimonial.name}</p>
                  <p className="text-sm text-gray-400">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Image Gallery Modal - Shows all photos */}
      <ImageGallery
        images={allPhotos.map((p) => p.src)}
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        title="Galerie complète Esprit Ouest"
        initialIndex={startIndex}
      />
    </section>
  );
};

export default Gallery;
